// extracted by mini-css-extract-plugin
export var actionPlaceholder = "_7q-3";
export var contentContainer = "_7q-0";
export var editorContainer = "_7q-1";
export var quillInputForm = "_7q-2";
export var zoneDivider = "_7q-4";